import {useState,Suspense} from "react";
import {Box,TextField,InputAdornment,IconButton,Button} from '@mui/material';
import {ArrowCircleRight} from '@mui/icons-material';
import {getPickListPopup} from '../../../custom/entities/PickListComponent.js';
import LoadingFallback from '../LoadingFallback.js';
import {DefaultConfig,evaluateReadOnly,consoleLog} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldTextJoin=({row,rowJoin,recordRules,fieldNameJoin,application,readOnly,userData,setFieldValue,setFieldChanged})=>{
    const [isPickListPopupOpen,setIsPickListPopupOpen]=useState(false);
    const [value,setValue]=useState(rowJoin[fieldNameJoin]?.value);
    const fieldName=rowJoin[fieldNameJoin].foreign_key;
    const fieldProp=row?.[fieldName];
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const isJoinPopulated=rowJoin?.[fieldNameJoin]?.id&&rowJoin?.[fieldNameJoin]?.id!=='';
    // The related id is always sent (it also marks the join as populated) - only offer the
    // drilldown when the model configured a link for it (may be role dependent)
    const drilldownLink=rowJoin?.[fieldNameJoin]?.drilldown_link;
    const required=isJoinPopulated===undefined?(fieldProp?.required?fieldProp?.required:false):false;
    const PickListPopup=getPickListPopup(rowJoin[fieldNameJoin]?.pick_list);
    
    const handleClickDrilldown=()=>{
        const url=drilldownLink.replace("{ENTITY_ID}", rowJoin?.[fieldNameJoin]?.id);
        window.open(url,'_blank','noopener,noreferrer');
    }
    const handleOpenPickListPopup=()=>{
        const pickListPopup=rowJoin[fieldNameJoin]?.pick_list;
        if(pickListPopup){
            setIsPickListPopupOpen(true);
        }
        else{
            consoleLog({file:'FieldTextJoin.js',context:'handleOpenPickListPopup',arg_name:'error',arg_value:'pickListPopup not defined'});
        }
    }

    const pickListCallback=(event)=>{
        if(event.name==='close_popup'){
            setIsPickListPopupOpen(false);
        }
        else if(event.name==='selectRow'){
            setFieldValue(fieldName,event?.id);
            setFieldChanged();
            for(const [key,value] of Object.entries(event?.pickMap)){
                if(key===fieldNameJoin){
                    setValue(value);
                }
            }
            setIsPickListPopupOpen(false);
        }
    }

    return (
        <>
        {isPickListPopupOpen&&
            <Suspense
                fallback={<LoadingFallback/>}>
                <PickListPopup pickListCallback={pickListCallback} application={application} userData={userData}/>
            </Suspense>}
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                style={{marginTop:"0px",marginBottom:"8px"}}
                sx={{div:{backgroundColor:readOnlyBackgroundColor}}}
                required={required}
                error={fieldProp?.validation_error?fieldProp?.validation_error:false}
                helperText={fieldProp?.validation_error_message?fieldProp?.validation_error_message:''}
                InputProps={{
                    readOnly:true,                                    
                    endAdornment:(
                        readOnlyEvaluated?
                        (isJoinPopulated&&drilldownLink&&
                            <InputAdornment position="end">
                                <IconButton onClick={(e)=>handleClickDrilldown()} color="primary">
                                    <ArrowCircleRight/>
                                </IconButton>
                            </InputAdornment>
                        ):(
                            <InputAdornment position="end">
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    onClick={(e)=>handleOpenPickListPopup()}>{isJoinPopulated?application.getLocale("ButtonUpdate"):application.getLocale("ButtonSelect")}
                                </Button>
                            </InputAdornment>
                        )
                    )
                }}
                id={fieldNameJoin}
                name={fieldNameJoin}
                fullWidth
                variant="outlined"
                size="small"
                label={rowJoin?.[fieldNameJoin]?.ui_label_locale?application.getLocale(rowJoin?.[fieldNameJoin]?.ui_label_locale):fieldNameJoin}
                value={value||''}
                margin="normal"/>
        </Box>
        </>
    );
}

export default FieldTextJoin;
